import React, { useContext } from 'react';
export let Products = /*#__PURE__*/function (Products) {
  Products["jira"] = "JIRA";
  Products["confluence"] = "CONFLUENCE";
  Products["other"] = "OTHER";
  return Products;
}({});
const primaryProductIndex = 0;
const ProductContext = /*#__PURE__*/React.createContext({
  products: [],
  activeIndex: primaryProductIndex,
  primaryProduct: ''
});
export const ProductProvider = ({
  children,
  products,
  activeIndex = 0,
  primaryProduct = ''
}) => /*#__PURE__*/React.createElement(ProductContext.Provider, {
  value: {
    products,
    activeIndex: Math.min(products.length - 1, Math.max(0, activeIndex)),
    primaryProduct
  }
}, children);
export const useProducts = () => useContext(ProductContext).products;

// Returns primaryProduct if defined else the first product is considered the primary
export const usePrimaryProduct = () => {
  const {
    products,
    primaryProduct
  } = useContext(ProductContext);
  return primaryProduct || products[primaryProductIndex];
};
export const useActiveProduct = () => {
  const context = useContext(ProductContext);
  return context.products[context.activeIndex];
};